import React, { useMemo } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PropTypes from 'prop-types'
import Typography from 'components/atoms/Typography'
import FilterButton from 'components/atoms/FilterButton'
import FilterButtonMobile from 'components/atoms/FilterButtonMobile'
import { flatten } from 'lodash'

function SectionFilterPlanOptions({ onChangeFilter, itemsActive, plans, items }) {
  // it's important for the plans not to change after some filter has been clicked
  // otherwise the plans options will desapear
  const initialPlans = useMemo(() => plans, [])
  const handleChangeFilter = (id) => {
    if (onChangeFilter) onChangeFilter(id)
  }

  // Remove items which doesn't have any plans for it
  function getPopulatedItems(callback) {
    const itemsPopulatedWithPlans = items.filter(({ id }) => {
      const categoriesWithPlans = initialPlans.map(({ category }) => {
        return category.map(({ entity }) => id === entity?.tid)
      })
      return flatten(categoriesWithPlans).includes(true)
    })
    return itemsPopulatedWithPlans.map(callback)
  }

  return (
    <>
      <Row className="d-lg-none">
        <Col>
          <FilterButtonMobile
            text="Filtrar planos por"
            items={Array.isArray(items) && items.map((i) => ({ ...i, value: i.id }))}
            onSubmit={handleChangeFilter}
          />
        </Col>
      </Row>
      <Row className="mt-3 pb-1 d-none d-lg-flex">
        <Col sm={12}>
          <Typography variant="p" component="" color="gray-100" cssClass="d-inline">
            Filtre planos por:
          </Typography>
          {Array.isArray(items) &&
            getPopulatedItems((item, index) => (
              <FilterButton
                active={Array.isArray(itemsActive) && itemsActive.find((i) => i === item.id)}
                key={index}
                text={item.name}
                onClick={() => handleChangeFilter(item.id)}
              />
            ))}
        </Col>
      </Row>
    </>
  )
}

SectionFilterPlanOptions.propTypes = {
  onChangeFilter: PropTypes.func,
  itemsActive: PropTypes.arrayOf(PropTypes.number),
  plans: PropTypes.array,
  items: PropTypes.array,
}

export default SectionFilterPlanOptions
